import styled from '@emotion/styled';
import { AppBar as MuiAppBar } from '@mui/material';

export const AppBar = styled(MuiAppBar)`
  background: ${(props) => props.theme.header.background};
  color: ${(props) => props.theme.header.color};
`;
